// extracted by mini-css-extract-plugin
export default {"submenuTabItem":"SubmenuTabItem_submenuTabItem__z-VPG","text":"SubmenuTabItem_text__hfthM"};